import { api } from '@marketplace-web/core-api/core-api-client-util'

import { CountriesSelectionResp } from '../types/countries'

export const getCountriesSelection = () => api.get<CountriesSelectionResp>('/country_selection')
